import { useForm } from 'antd/es/form/Form';
import { useEffect } from 'react';

import { useUpsertBranchMedicalExtensionMutation } from '@app/api/MedicalDocuments';
import type { ModelBranchMedicalExtension } from '@app/api/MedicalDocuments';
import { SUCCESS, SUCCESS_MESSAGE } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

import type { UseBranchMedicalExtensionProps } from '../types';

export const useBranchMedicalExtension = ({
  branchId,
  data,
}: UseBranchMedicalExtensionProps) => {
  const { showNotification } = useNotification();
  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const [form] = useForm();

  const [upsertBranchMedicalExtension, { isLoading: isUpsertLoading }] =
    useUpsertBranchMedicalExtensionMutation();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        FrmoOid: data.FrmoOid,
      });
    }
  }, [data, form]);

  const handleFinish = async (
    values: Omit<ModelBranchMedicalExtension, 'BranchId'>
  ) => {
    try {
      await upsertBranchMedicalExtension({
        ActiveBranchId,
        data: { BranchId: branchId, FrmoOid: values.FrmoOid },
      }).unwrap();

      showNotification(SUCCESS_MESSAGE, SUCCESS);
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  };

  return { form, isLoading: isUpsertLoading, handleFinish };
};
